import { LoadingModule } from '../loading/loading.module';
import { NgModule,NO_ERRORS_SCHEMA,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import {CommonModule} from '@angular/common';
import { CollaboratorsComponent } from './collaborators.component';
import { CollaboratorsRoutingoModule } from './collaborators-routing.module';
@NgModule({
  imports: [
    CollaboratorsRoutingoModule,
    HttpClientModule,
    CommonModule,
    LoadingModule
  ],
  declarations: [CollaboratorsComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class CollaboratorsModule { }
